// The emojis a player can send during a game. The same ones, in the same order, as EMOJIS in
// backend/emoji_reactions.py (emojis.test.js checks it): the server refuses any other.
export const EMOJIS = ["😂", "😎", "😍", "😭", "😱", "🤬", "🤔", "😴", "👏", "🔥", "☕", "🃏"];

// How long it stays on screen. The player sends the next one once it has left (the server's own
// gap, MIN_GAP_S, is a little shorter, for a slow network).
export const EMOJI_SHOW_MS = 3000;
